import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CListeComponent } from './c-liste.component';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SortArrayByParameterModule } from 'src/app/pipes/sort-array-by-parameter/sort-array-by-parameter.module';
import { CTypeaheadModule } from '../../c-typeahead/c-typeahead.module';

import { AsPipesModule } from '../../../pipes/as-pipes/as-pipes.module';

@NgModule({
  declarations: [CListeComponent],
  imports: [
    ReactiveFormsModule,
    CommonModule,
    IonicModule,
    FontAwesomeModule,
    SortArrayByParameterModule,
    CTypeaheadModule,
    AsPipesModule
  ],
  exports: [CListeComponent]
})
export class CListeModule { }
